import { compose } from 'shared/utils/function.utils';
import { getNavigationTreeReducer } from './get-navigation-tree';

export const extraReducers = compose(getNavigationTreeReducer);

export { getNavigationTreeAction } from './get-navigation-tree';
